import { Link } from 'components/Ui-Kits/Text/Link'
import { useQuery } from 'hooks/query/useQuery'
import { any, array, number, string } from 'prop-types'
import { useMemo } from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import qs from 'qs'
import { omit } from 'lodash'
import { theme } from 'globalStyles'

export const CategoryItem = ({ values, label, value, childrenOptions, name, depth = 1 }) => {
  const childrenValues = useMemo(() => extractChildrenValues(childrenOptions || []), [childrenOptions])
  const history = useHistory()

  const childrenVisible = useMemo(
    () => (!values && !value) || values == value || childrenValues.includes(values),
    [value, childrenValues, values]
  )

  const query = useQuery()
  const link = useMemo(() => {
    const newQueryData = omit(query, name)
    if (value) {
      newQueryData[name] = value
    }

    return history.location.pathname + '?' + qs.stringify(newQueryData)
  }, [query, value, name, history])

  return (
    <>
      <StyledLink to={link} pl={depth} size={1} bold={childrenVisible}>
        {label}
      </StyledLink>
      {!!childrenOptions?.length && (
        <ChildrenWrap show={childrenVisible}>
          {childrenOptions.map(({ label, value, children }) => (
            <CategoryItem
              label={label}
              value={value}
              key={value}
              name={name}
              values={values}
              childrenOptions={children}
              depth={depth + 1}
            />
          ))}
        </ChildrenWrap>
      )}
      {depth === 1 && <Line />}
    </>
  )
}

CategoryItem.propTypes = {
  name: string,
  values: array,
  label: string,
  value: any,
  childrenOptions: array,
  depth: number,
}

const extractChildrenValues = options =>
  options.reduce((result, current) => [...result, current.value, ...extractChildrenValues(current.children || [])], [])

const ChildrenWrap = styled.div`
  display: ${({ show }) => (show ? 'block' : 'none')};
`
const StyledLink = styled(Link)`
  display: block;
  padding-left: ${({ pl }) => pl}rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  ${({ bold }) => bold && `font-weight: bold;`}
  margin-bottom: 0.625rem;
  &:hover {
    background-color: #e7e7e7;
  }
`
const Line = styled.div`
  display: block;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
  height: 1px;
  background-color: #dddddd;
  &:last-of-type {
    display: none;
  }

  ${theme.breakpoints.tablet} {
    display: none;
    &:first-of-type {
      display: block;
    }
  }
`
